<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="main-head">

          <div class="row">
            <div class="col-md-8">
              <div class="head-left">
                <router-link to="/subjects" class="m-menu__link btn btn-info">{{course_name}}</router-link>
                <h2>{{chapterData.code}} : {{chapterData.name}}</h2>
                <div class="sub-row">
                  <div class="head-topic">{{chapterData.topicCount}} Topics</div>
                  <div class="head-topic">|</div>
                  <div class="head-topic">{{chapterData.chapterDuration}} Hours</div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="head-right">
                <a href="#" class="btn btn-info" @click="goBacktoSubject()">Back</a>
              </div>
            </div>
          </div>

        </div>
        <div class="m-portlet">
          <div class="m-portlet__body">

            <div class="row">
              <div class="col-md-12">
                <div class="card description">
                  <div class="card-header">Description</div>
                  <div class="card-body">
                    {{chapterData.description}}
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- begin::Chapters Card Column -->
              <div class="col-md-12 col-sm-12">
                <!-- begin::Chapters Card Block -->
                <div id="accordion" class="topic-list-area">
                  <div class="card" v-for="(chapter,index) in this.chapters" :key="index">
                    <div class="card-header" :id=chapter.id>
                      <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse' + index" aria-expanded="true" :aria-controls=chapter.id>Chapter: {{chapter.name}}
                        </button>
                        <span>{{chapter.duration}} Hours</span>
                      </h5>
                    </div>
                    <div :id="'collapse' + index" class="collapse" :class="(index === 0)? 'show' : ''" :aria-labelledby=chapter.id data-parent="#accordion">
                      <div class="card-body">
                          <ul>
                            <li v-for="(topic,index) in chapter.topics" :key="index" @click="gotoTopic(chapter.id, topic.id, topic.showTopic)" :class="(topic.showTopic == false)?'disable_topic' : 'show_topic'">
                              <div>
                                <a>{{topic.name}}</a>
                                <span class="topic_appear_in_days" v-if="topic.showTopic == false">available on {{topic.topicAppearInDays}}</span>
                              </div>
                              <span>{{topic.duration}} Hours</span>
                            </li>
                          </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End::Chapters Card Block -->
              </div>
              <!-- End::Chapters Card Column -->
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
  </div>
</template>

<script>
var Config = require('../router/Config')
// var $ = require('jquery')
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')

module.exports = {
  name: 'chapters',
  props: [],
  data () {
    return {
      chapterData: '',
      chapters: [],
      chapterBackground: '',
      course_name: Cookies.get('courseName')
    }
  },
  beforeCreate: function () {
    if (!userPermissions.course_view) {
      this.$router.push('/')
    }
  },
  mounted () {
    this.getChapterInfo()
  },
  methods: {
    getChapterInfo: function () {
      this.axios.get(Config.API_URL + '/api/fe/subject/chapters/' + Cookies.get('subjectId') + '/' + Cookies.get('courseId') + '?token=' + Cookies.get('accessToken')).then(response => {
        this.chapterData = response.data
        this.chapters = this.chapterData.chapters
        this.chapterBackground = this.chapterData.icon_bg_color
      }).catch(function (error) {
        console.log(error)
      })
    },
    gotoTopic: function (chapterId, topicId, showTopic) {
      if (showTopic != false) {
        Cookies.set('chapterId', chapterId)
        Cookies.set('topicId', topicId)
        this.$router.replace({ name: 'topics' })
      }     
    },
    goBacktoSubject: function () {
      Cookies.get('courseId')
      this.$router.replace({ name: 'subjects' })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/component/chapters/chapters";
</style>
